module.exports = __webpack_public_path__ + "img/tiandiandian.5db05c81.png";